import { store } from '../state';
import { $localization } from '../state/preferences.state';

export const getLocale = (): string => {
  const { language, defaultCountry } = store.get($localization);
  if (defaultCountry) {
    return `${language}-${defaultCountry}`;
  }
  return language || 'en-US';
};
